/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type MethodologyEnum = (typeof MethodologyEnum)[keyof typeof MethodologyEnum];

export const MethodologyEnum = {
  'positive-reinforcement': 'positive-reinforcement',
  balanced: 'balanced',
  dominance: 'dominance',
} as const;
